var contractApp = angular.module('contract', ['commons.app']);
